import { render, staticRenderFns } from "./TemplateWidgetsForm.vue?vue&type=template&id=0b1a6f01"
import script from "./TemplateWidgetsForm.vue?vue&type=script&lang=js"
export * from "./TemplateWidgetsForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateWidgetsForm.vue?vue&type=style&index=0&id=0b1a6f01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports